import { render, staticRenderFns } from "./drawerButton.vue?vue&type=template&id=ede38f22&"
import script from "./drawerButton.vue?vue&type=script&lang=js&"
export * from "./drawerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports